import React from 'react';
import TopNavbar from '../components/TopNavbar';
import MainHeader from '../components/MainHeader';
import Footer from '../components/Footer';

const reviews = [
  {
    id: 1,
    name: 'Sarah M.',
    title: 'Beautiful quality and fast delivery',
    rating: 5,
    date: 'October 12, 2025',
    message:
      'The sofas we ordered look even better in real life. The fabric feels premium and the delivery team was very professional.',
    location: 'Nairobi, Kenya',
  },
  {
    id: 2,
    name: 'James K.',
    title: 'Exactly what our living room needed',
    rating: 4,
    date: 'September 28, 2025',
    message:
      'We bought a TV stand and coffee table set. Assembly was simple and the finish is very clean and modern.',
    location: 'Kiambu, Kenya',
  },
  {
    id: 3,
    name: 'Anita W.',
    title: 'Great customer support',
    rating: 5,
    date: 'August 9, 2025',
    message:
      'Customer care helped me choose the right size for my dining set and kept me updated throughout the process.',
    location: 'Mombasa, Kenya',
  },
  {
    id: 4,
    name: 'Brian O.',
    title: 'Very comfortable bed frame',
    rating: 5,
    date: 'July 21, 2025',
    message:
      'Sturdy, comfortable and looks premium. I will definitely come back for more pieces.',
    location: 'Nakuru, Kenya',
  },
];

const StarRating = ({ rating }) => {
  return (
    <div className="flex items-center space-x-1">
      {Array.from({ length: 5 }).map((_, index) => {
        const filled = index + 1 <= rating;
        return (
          <svg
            key={index}
            className={`w-4 h-4 ${filled ? 'text-orange-400' : 'text-gray-300'}`}
            fill="currentColor"
            viewBox="0 0 20 20"
          >
            <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
          </svg>
        );
      })}
    </div>
  );
};

const Reviews = () => {
  return (
    <div className="App bg-white min-h-screen">
      <TopNavbar />
      <MainHeader />
      <main className="max-w-6xl mx-auto px-4 py-12">
        <div className="text-center mb-12">
          <h1 className="text-3xl md:text-4xl font-bold text-gray-900 mb-3">
            What Our Customers Say
          </h1>
          <p className="text-gray-600 max-w-2xl mx-auto">
            Real feedback from homeowners who chose Brand Decor to style their spaces.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {reviews.map((review) => (
            <article
              key={review.id}
              className="bg-gray-50 border border-gray-200 rounded-2xl p-6 md:p-7 shadow-sm hover:shadow-md transition-shadow duration-300"
            >
              <div className="flex items-start justify-between mb-4">
                <div>
                  <h2 className="text-lg font-semibold text-gray-900 mb-1">
                    {review.title}
                  </h2>
                  <p className="text-sm text-gray-500">
                    {review.name}  b7 {review.location}
                  </p>
                </div>
                <div className="text-right">
                  <StarRating rating={review.rating} />
                  <p className="text-xs text-gray-400 mt-1">{review.date}</p>
                </div>
              </div>

              <p className="text-gray-700 text-sm leading-relaxed">
                 22{review.message} 22
              </p>
            </article>
          ))}
        </div>

        <div className="mt-12 text-center text-sm text-gray-500">
          <p>
            You can also leave a rating on any product by opening its details from the home or shop page.
          </p>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default Reviews;
